export default __webpack_public_path__ + "static/media/Nidhi-2.c88dfe0b.jpg";